export default __webpack_public_path__ + "static/media/clouds.f4881849.jpg";